import MapboxDraw from "@mapbox/mapbox-gl-draw";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import {
  DRAW_MODES,
  DRAW_STYLES,
  SNAP_OPTIONS,
  DRAW_CONTROLS,
} from "./drawToolsConfig";
import {
  handleDrawCreate,
  handleSelectionChange,
  handleModeChange,
  createResetModalTrigger,
  handleFeatureClick,
} from "./drawToolsEventHandlers";
import { addImportContourButton } from "./drawToolsImportControl";
import { addExportContourButton } from "./drawToolsExportControl";
export const addDrawTools = (
  mapRef,
  drawRef,
  editingRef,
  originalGeometryRef,
  markersRef,
  setCurrentPopupFeature,
  onImportError,
  onImportSuccess,
  onExport,
) => {
  const map = mapRef.current;

  // Prevent re-adding Draw
  if (map._drawInstanceAdded) {
    console.warn("Draw tools already added to map");
    return;
  }

  // Initialize Mapbox Draw
  const draw = new MapboxDraw({
    modes: DRAW_MODES,
    styles: DRAW_STYLES,
    userProperties: true,
    snap: true,
    snapOptions: SNAP_OPTIONS,
    guides: false,
    displayControlsDefault: false,
    controls: DRAW_CONTROLS,
  });

  drawRef.current = draw;

  // Add the draw control to the map
  map.addControl(draw, "bottom-right");
  setTimeout(() => {
    addDataTestIdsToDrawControls();
    addImportContourButton({
      mapRef,
      drawRef,
      onImportError,
      onImportSuccess,
    });
    addExportContourButton({
      mapRef,
      drawRef,
      onExport,
    });
  }, 100);
  // Create reset modal trigger
  const triggerResetModal = createResetModalTrigger(
    drawRef,
    editingRef,
    originalGeometryRef,
  );

  // Event: draw.create
  map.on("draw.create", (e) => {
    handleDrawCreate(e, drawRef, mapRef, markersRef);
  });

  // Event: draw.selectionchange
  map.on("draw.selectionchange", () => {
    handleSelectionChange(drawRef, editingRef);
  });

  // Event: draw.modechange
  map.on("draw.modechange", (event) => {
    handleModeChange(
      event,
      drawRef,
      editingRef,
      originalGeometryRef,
      triggerResetModal,
    );
  });

  // Event: feature click (for all interaction types)
  const clickHandler = (e) => {
    handleFeatureClick(e, drawRef, setCurrentPopupFeature);
  };

  map.on("click", clickHandler);
  map.on("touchstart", clickHandler);
  map.on("touchend", clickHandler);
  map.on("touchcancel", clickHandler);

  // Mark as added
  map._drawInstanceAdded = true;
  map._drawInstance = draw;
};
const addDataTestIdsToDrawControls = () => {
  // Point button
  const pointButton = document.querySelector(".mapbox-gl-draw_point");
  if (pointButton) {
    pointButton.setAttribute("data-testid", "draw-point-button");
  }

  // Line button
  const lineButton = document.querySelector(".mapbox-gl-draw_line");
  if (lineButton) {
    lineButton.setAttribute("data-testid", "draw-line-button");
  }

  // Polygon button
  const polygonButton = document.querySelector(".mapbox-gl-draw_polygon");
  if (polygonButton) {
    polygonButton.setAttribute("data-testid", "draw-polygon-button");
  }
};
export const removeDrawTools = (mapRef, drawRef, markersRef) => {
  const map = mapRef.current;

  if (!map || !map._drawInstanceAdded) return;

  // Remove all markers
  if (markersRef && markersRef.current) {
    markersRef.current.forEach((marker) => marker.remove());
    markersRef.current.clear();
  }

  // Remove draw control
  if (drawRef.current && map._drawInstance) {
    map.removeControl(drawRef.current);
  }

  // Reset flags
  map._drawInstanceAdded = false;
  map._drawInstance = null;
  drawRef.current = null;
};
